import Header from "../components/Header";
import Footer from "../components/Footer";
import "./Contact.css";
import { Link } from "react-router-dom";
import innerbanner from "../assets/images/contact-banner.png";
import contactimg from "../assets/images/contact-form-img.png";

function Contact() {
  return (
    <>
      <Header />

      <div className="contact_us_main">
        <div className="container-fluid">
          <div
            className="inner_banner_contact"
            style={{ backgroundImage: `url(${innerbanner})` }}
          >
            <div className="text_on_img">
              <div className="breadcrumb">
                <Link to="/">Home</Link>
                <span> &gt; </span>
                <Link to="/contact">Contact Us</Link>
              </div>
              <h1 className="bread_heading">Contact Us</h1>
              <p className="bread_peraa">
                Have questions about our medical equipment rentals? Get in touch
                with CaresAtHome for product details, rental options,
                availability, or delivery assistance. Our team is ready to help.
              </p>
            </div>
          </div>

          <div className="contact_us_section">
            <div className="row">
              <div className="col-lg-6 col-md-5 col-sm-12 col-12">
                <div className="contact_form_img">
                  <img src={contactimg} alt="contact-form-img" />
                </div>
              </div>
              <div className="col-lg-6 col-md-7 col-sm-12 col-12">
                <div className="contact_form">
                  <h2>Send Us a Message</h2>
                  <p>
                    Fill out the contact form and our healthcare team will get
                    back to you as soon as possible.
                  </p>
                  <form className="contact_us_form-main">
                    <div className="row">
                      <div className="col-lg-6">
                        <label>Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder=""
                        />
                      </div>

                      <div className="col-lg-6">
                        <label>Email</label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder=""
                        />
                      </div>

                      <div className="col-lg-6">
                        <label>Phone Number</label>
                        <input
                          type="tel"
                          className="form-control"
                          placeholder=""
                        />
                      </div>

                      <div className="col-lg-6">
                        <label>Subject</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder=""
                        />
                      </div>

                      <div className="col-lg-12">
                        <label>Message</label>
                        <textarea
                          rows="5"
                          className="form-control"
                          placeholder=""
                        ></textarea>
                      </div>

                      <div className="col-lg-12">
                        <button
                          type="submit"
                          className="contact_btn form_submit_btn"
                        >
                          SUBMIT
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Contact;
